var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"bottom-four",attrs:{"title":"温度-物联网故障"}},[_c('LineCharts',{attrs:{"id":"wlwgz","lists":_vm.datas,"areaColor":_vm.areaColor,"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }